import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export const ConfirmationBox = ({ ...props }) => {
  const { showModel } = props;
  const { t } = useTranslation();
  return (
    <Modal show={showModel} onHide={props.onCancel}>
      <Modal.Header>
        <Modal.Title> {props.header ? props.header : t('Payment.Model.header')}</Modal.Title>
        <button type="button" className="close" onClick={props.onCancel} data-testid="closeButton">
          <span aria-hidden="true">×</span>
          <span className="sr-only">{t('Payment.Model.button.close')}</span>
        </button>
      </Modal.Header>
      <Modal.Body className="pb-0 pt-3">
        {props.bodyMessage ? <span>{props.bodyMessage}</span> : <span>{props.Message}</span>}
      </Modal.Body>
      <Modal.Footer className="pb-3">
        <div className="btn-block clearfix mt-3">
          <button
            type="button"
            className="btn btn-primary mr-2 mb-2"
            title={props.confirmText ? props.confirmText : String(t('Payment.Model.button.yes'))}
            onClick={props.onConfirm}
          >
            <span>{props.confirmText ? props.confirmText : t('Payment.Model.button.yes')}</span>
          </button>
          <button
            type="button"
            className="btn btn-secondary mb-2"
            title={props.cancelText ? props.cancelText : String(t('Payment.Model.button.no'))}
            onClick={props.onCancel}
          >
            <span>{props.cancelText ? props.cancelText : t('Payment.Model.button.no')}</span>
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default ConfirmationBox;
